import LogoPreSeed from "../assets/logo_pre_seed.svg";
import ContactForm from "../base-components/ContactForm";
import {useEffect, useState} from "react";

function InfoSection() {

    const [isContactFormOpen, setIsContactFormOpen] = useState(false);

    const scrollToContact = () => {
        const el = document.getElementById("contact-form");
        if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    };

    const handleScroll = () => {
        if (isContactFormOpen) {
            scrollToContact();
        }
        else {
            setIsContactFormOpen(true);
        }
    }

    useEffect(() => {
        if (isContactFormOpen) {
            scrollToContact();
        }
    }, [isContactFormOpen])

    return (
        <section aria-label="Info section" className="bg-dark h-full">
            <div className="flex flex-col justify-center items-center gap-[5vw]">
                <div className="relative w-[90%] h-[10vw] mt-[5vw] bg-hero flex
                                md:h-[5vw]">
                    <div
                        className="h-full w-1/3 bg-yellow flex items-center px-[2vw] z-10"
                        style={{
                            clipPath: 'polygon(0 0, 100% 0, 85% 50%, 85% 100%, 0 100%)'
                        }}
                    >
                        <p className="text-black font-[900] text-[3vw]
                                        md:text-[2vw]">
                            IA PER TUTTI
                        </p>
                    </div>
                    <div className="flex-1 flex items-center px-[2vw] justify-end">
                        <p className="text-light font-[900] text-[1.9vw]
                                        md:text-[1.7vw]">
                            Accesso senza limiti, anche per dilettanti e amatori!
                        </p>
                    </div>
                </div>
                <div className="relative w-[90%] h-[10vw] bg-yellow flex
                                md:h-[5vw]">
                    <div
                        className="relative h-full w-2/3 bg-hero flex items-center px-[2vw] z-10"
                        style={{
                            clipPath: 'polygon(0 0, 85% 0, 95% 50%, 95% 100%, 0 100%)'
                        }}
                    >
                        <p className="text-light font-[900] text-[1.9vw]
                                        md:text-[1.7vw]">
                            Dati chiari per allenatori, atleti e appassionati
                        </p>
                    </div>
                    <div className="flex-1 flex items-center justify-end px-[2vw]">
                        <p className="text-black font-[900] text-[2.1vw]
                                        md:text-[2vw]">
                            STATISTICHE SMART
                        </p>
                    </div>
                </div>
                <div className="flex flex-row w-[90%] text-light font-[400] text-[3vw]
                                md:text-[1.5vw]">
                    Sostenuti nell’ambito dell’Avviso PR FESR Lazio 2021-2027.<br/>PRE-SEED Plus approvato con
                    Determinazione n. G04507 del 12/04/2022 e pubblicato sul B.U.R.L. n. 32
                    del 14/04/2022.<br/>CUP: F88I24001940009<br/>Contributo concesso: 10.000,00 €
                </div>
                <div className="flex flex-row w-[90%]">
                    <img src={LogoPreSeed} alt="Logo PreSeed" className="w-full"/>
                </div>
                <button
                    onClick={handleScroll}
                    className="rounded-full border-[0.4vw] border-light text-light text-[5vw] font-[400] hover:bg-hero mb-20 inline-block text-center py-[1vw] px-[4vw]
                                md:text-[4vw] md:px-[3vw]
                                lg:text-[3vw] lg:px-[2vw]"
                >
                    SCOPRI DI PIÙ
                </button>
                {isContactFormOpen && <ContactForm projectName={"AiLights"}/>}
            </div>
        </section>
    )
}

export default InfoSection
